import React, {ReactElement} from 'react';
import Typography from '@material-ui/core/Typography';
import {
    MediaOrdersItemType,
    WorkflowStateType,
    WFState,
    MediaOrdersItemKeys,
} from '../MediaOrdersTypes';

export const renderStatus = (workflowState: WorkflowStateType = {}) => (
    row: MediaOrdersItemType
): ReactElement => {
    const name = row[MediaOrdersItemKeys.status];
    const statusName = workflowState[name] ?? name;

    if (row[MediaOrdersItemKeys.isRemoved]) {
        return <Typography className="status-dark-grey">{statusName}</Typography>;
    }

    switch (name) {
        case WFState.QC_FAILED:
        case WFState.DELIVERY_FAILED:
            return <Typography className="status-red">{statusName}</Typography>;
        case WFState.DELIVERY_PENDING:
            return <Typography className="status-orange">{statusName}</Typography>;
        case WFState.INGEST_FAILED:
            return <Typography className="status-dark-grey">{statusName}</Typography>;
        case WFState.DELIVERY_CANCELLED:
            return <Typography className="status-grey">{statusName}</Typography>;

        default:
            return <Typography className="status-white">{statusName}</Typography>;
    }
};

export const renderCell = (key: keyof MediaOrdersItemType) => (
    row: MediaOrdersItemType
): ReactElement => {
    if (
        row[MediaOrdersItemKeys.isRemoved] ||
        row[MediaOrdersItemKeys.status] === WFState.INGEST_FAILED
    ) {
        return <Typography className="status-dark-grey">{row[key]}</Typography>;
    }

    return <Typography className="status-white">{row[key]}</Typography>;
};

export const tableColumns = (workflowState: WorkflowStateType) => [
    {
        dataKey: MediaOrdersItemKeys.title,
        title: 'Title',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.title),
    },
    {
        dataKey: MediaOrdersItemKeys.seasonNumber,
        title: 'Season #',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.seasonNumber),
    },
    {
        dataKey: MediaOrdersItemKeys.episodeNumber,
        title: 'Episode #',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.episodeNumber),
    },
    {
        dataKey: MediaOrdersItemKeys.status,
        title: 'Workflow state',
        render: renderStatus(workflowState),
    },
    {
        dataKey: MediaOrdersItemKeys.availsId,
        title: 'Avails id',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.availsId),
    },
    {
        dataKey: MediaOrdersItemKeys.dueDateToLab,
        title: 'Partner due date to lab',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.dueDateToLab),
    },
    {
        dataKey: MediaOrdersItemKeys.dueDateToPluto,
        title: 'Lab due date to Pluto',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.dueDateToPluto),
    },
    {
        dataKey: MediaOrdersItemKeys.trt,
        title: '# Qty or Est. TRT (min):',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.trt),
    },
    {
        dataKey: MediaOrdersItemKeys.clipRating,
        title: 'Rating',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.clipRating),
    },
    {
        dataKey: MediaOrdersItemKeys.territoriesInclude,
        title: 'Territories Include',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.territoriesInclude),
    },
    {
        dataKey: MediaOrdersItemKeys.language,
        title: 'Language',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.language),
    },
    {
        dataKey: MediaOrdersItemKeys.serviceTier,
        title: 'Service Tier',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.serviceTier),
    },
    {
        dataKey: MediaOrdersItemKeys.partnerCode,
        title: 'Partner code',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.partnerCode),
    },
    {
        dataKey: MediaOrdersItemKeys.associatedStatus,
        title: '',
        sortable: true,
        render: renderCell(MediaOrdersItemKeys.associatedStatus),
    },

    // temporarily hide delete button
    //     {
    //     dataKey: '',
    //     title: '',
    //     render: renderRestoreOrDeleteIcon({
    //         deleteItem,
    //         restoreItem,
    //         removedIds,
    //         setRemovedIds,
    //         mediaOrderId: id,
    //     }),
    // }
];
